// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3OOSn","errorLogs":"styles_errorLogs__5kV3N"};